import {Text} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

export const StyledWarningLabel = styled(Text)(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm}
        color: ${palette.orange[800]};
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 400;

        & svg {
            width: 14px;
            height: 14px;
            color: ${palette.orange[500]};
        }
    `
)
